import React from 'react';
import { useViewChangeTracker } from '../../../hooks/useViewChangeTracker';
import { GenesGtpHeatmap } from './GenesGtpHeatmap';

type GenesGraphsProps = {
  source: string;
  view: string;
  names: Array<{ id: string; name?: string; label?: string }>;
};

function GenesGraphs({ source, view, names }: GenesGraphsProps) {
  useViewChangeTracker('GenesGraphs', view, 'graph');

  return <GenesGtpHeatmap source={source} view={view} names={names} />;
}

export default React.memo(GenesGraphs);
